import { useMutation } from '@tanstack/react-query';

import { fetchListTwoApi } from '../api';

export default function useListTwoMutation(options?: any) {
  return useMutation(fetchListTwoApi, options);
}
